module.exports = __webpack_public_path__ + "img/galeria-pacs-clinicas-2.4e2cb742.png";